<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<config-sidenav></config-sidenav>
			<div id="content" class="app-content box-shadow-3">
				<div id="navbar" class="navbar navbar-expand-lg">
					<!-- Page title -->
					<loading type="header" v-if="essential_skill.loaded == 0" />
					<div v-if="essential_skill.loaded != 0" class="navbar-text nav-title flex" id="pageTitle">
						{{ essential_skill.name }}
					</div>
				</div>

				<div class="content-main" style="background-color:white">
					<!-- Page content goes here -->
					<div class="h-100" v-if="essential_skill.loaded != 0">
						<div class="d-sm-flex b-t h-100">
							<edit-pane :cancel="loadData" :save="saveEssentialSkill" :dirty="dirty" :valid="valid">
								<div class="p-4 p b-b _600 nav-title">Essential Skill Details</div>
								<div class="d-flex flex-row m-0 padding">
									<div class="ml-4 flex" style="max-width: 500px;">
										<div class="form-group" :class="{ invalid: !valid.field('name') }">
											<label>Essential Skill Name</label>
											<input type="text" class="form-control" v-model="essential_skill.name" />
										</div>
									</div>
								</div>
								<div class="d-flex flex-row m-0 padding">
                                    <div class="col-12">
                                            <div class="form-group">
                                                <label>Description</label>
                                                <RichText
                                                    :text.sync="essential_skill.description"
                                                    :initial="originalDesc"
                                                    :options="{height: 140}"
                                                    :refresh="refresh"
                                                    class="border"
                                                ></RichText>
                                            </div>
                                        </div>
								</div>

							</edit-pane>
							<save-optional-modal
								:dirty="dirty"
								:valid="valid"
								:save="saveEssentialSkill"
								:next="saveOptNext"
								:cancel="saveOptCancel"
								objectText="EssentialSkill"
								:objectName="essential_skill.name"
								actionText="leave the page"
								v-model="saveOptModal"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<style scoped>
.margin-overlap {
	margin-right: -2.5rem;
}
.padding{
    padding-bottom: 0px !important;
}
</style>

<script>
import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import ImagePicker from "@/components/ImagePicker";
import RichText from "@/components/RichText";

import EssentialSkillService from "@/services/EssentialSkillService";
import ValidationService from "@/services/ValidationService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import Utils from "@/services/Utils";

export default {
	name: "EssentialSkillEdit",

	props: ["user", "params", "query"],

	components: {
		EditPane,
		SaveOptionalModal,
        ImagePicker,
        RichText
	},

	data() {
		return {
			fs: fs,
			tab: 1,
			essential_skill: {
				loaded: 0
            },
            originalDesc: "",
			dirty: false,
			valid: {},
			saveOptModal: false,
			saveOptNext: () => {},
			saveOptCancel: () => {}
		};
	},

	computed: {},

	created() {
		this.loadData();
		this.initValidation();

		if (this.query.tab) {
			this.tab = this.query.tab;
		}
	},

	watch: {},

	beforeRouteLeave(to, from, next) {
		if (this.dirty) {
			this.saveOptNext = () => {
				next();
			};
			this.saveOptCancel = () => {
				next(false);
			};
			this.saveOptModal = true;
		} else {
			next();
		}
	},

	methods: {
		initValidation() {
			this.valid = ValidationService.newValidator({
				name: {
					group: "details",
					errorMsg: "You must assign a name",
					func: () => {
						return this.essential_skill && this.essential_skill.name && this.essential_skill.name != "";
					}
				}
			});
		},
        loadDesc(){
            if(this.essential_skill){
                return this.essential_skill.description
            }
            return ""
        },
		blankEssentialSkill() {
			return {
				loaded: 0
			};
		},

		watchChanges() {
			if (this.unwatch) {
				this.unwatch();
			}
			this.unwatch = this.$watch(
				"essential_skill",
				(newc, old) => {
					// console.log(newc, old);
					// console.log(Utils.diff(newc, old));
					// console.log("marking dirty");
					this.dirty = true;
				},
				{ deep: true }
			);
		},

		loadData() {
			this.dirty = false;
			var loaded = this.essential_skill.loaded;
			loaded++;

			if (this.params.id != "new") {
				return EssentialSkillService.getEssentialSkill(this.params.id)
					.then(resp => {
						this.essential_skill = resp.data;
						this.essential_skill.loaded = loaded;
                        this.originalDesc = this.essential_skill.description
						this.watchChanges();
					})
					.catch(err => {
						console.log(err);
						Notie.error("Essential Skill not found, adding new Essential Skill instead");
						this.$router.replace("/essential_skills/new");
					});
			} else {
				this.essential_skill = this.blankEssentialSkill();
				this.essential_skill.loaded = loaded;
				this.$set(this.essential_skill, "name", "New Essential Skill");

				this.watchChanges();
			}
		},

		saveEssentialSkill() {
			return EssentialSkillService.saveEssentialSkill(this.essential_skill)
				.then(resp => {
					Notie.info("Essential Skill Saved");
					if (this.essential_skill.id != resp.data.id) {
						this.$router.replace("/essential_skill/" + resp.data.id);
					}
					this.$router.go(-1)
					this.loadData();
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to save Essential Skill", err);
				});
		},

		canSave() {
			return this.dirty;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/SetupConfig/EssentialSkillEdit.vue